






































































































































































import { Component, Vue } from "vue-property-decorator";
import AuditPembersihanLingkunganService from "@/services/AuditPembersihanLingkunganService";
import AuditPembersihanLingkunganKriteriaLogger from "./AuditPembersihanLingkunganKriteriaLogger.vue";
import AuditPembersihanLingkunganDetail from "./AuditPembersihanLingkunganDetail.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { userModule } from "@/store/modules/user";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import {
  APL_ITEM_COUNT,
  AUDIT_PEMBERSIHAN_LINGKUNGAN_PRIVILEGE,
  METODE_AUDIT_OPTIONS
} from "@/constants/kriteriaAuditPembersihanLingkungan";

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

function emptyForm() {
  const now = new Date();
  return {
    unit_id: "",
    unit_nama: "",
    tanggal_audit: localISODate(now),
    waktu_mulai: `${pad2(now.getHours())}:${pad2(now.getMinutes())}`,
    metode_audit: "observasi_langsung",
    periode_bulan: now.getMonth() + 1,
    periode_tahun: now.getFullYear(),
    auditor_nama: "",
    auditor_sip_str: "",
    auditor_jabatan: "Komite PPI"
  };
}

@Component({
  components: {
    AuditPembersihanLingkunganKriteriaLogger,
    AuditPembersihanLingkunganDetail,
    UnitRuangPicker,
    PersonAutoComplete,
    VCDateTimePicker
  }
})
export default class AuditPembersihanLingkunganList extends Vue {
  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;

  itemCount = APL_ITEM_COUNT;
  metodeOptions = METODE_AUDIT_OPTIONS;
  unitKategori = ["ralan", "penunjang", "ranap"];

  form = emptyForm();

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "TTD Ka. Ruang / Petugas Jaga", value: "acknowledged" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 },
    { text: "Maret", value: 3 }, { text: "April", value: 4 },
    { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 },
    { text: "September", value: 9 }, { text: "Oktober", value: 10 },
    { text: "November", value: 11 }, { text: "Desember", value: 12 }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_audit" },
    { text: "Unit", value: "unit_nama" },
    { text: "% Patuh", value: "compliance_rate_total" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 120 }
  ];

  get canCreate(): boolean {
    return userModule.hasPrivilege(AUDIT_PEMBERSIHAN_LINGKUNGAN_PRIVILEGE, "create");
  }

  get canSubmitCreate(): boolean {
    return !!(
      this.form.unit_id &&
      this.form.tanggal_audit &&
      this.form.metode_audit &&
      this.form.periode_bulan &&
      this.form.periode_tahun
    );
  }

  get filterTglDariDate(): Date | null {
    return parseLocalDate(this.filterTglDari);
  }

  set filterTglDariDate(val: Date | null) {
    this.filterTglDari = val ? localISODate(val) : "";
    this.loadData();
  }

  get filterTglSampaiDate(): Date | null {
    return parseLocalDate(this.filterTglSampai);
  }

  set filterTglSampaiDate(val: Date | null) {
    this.filterTglSampai = val ? localISODate(val) : "";
    this.loadData();
  }

  get tanggalAuditDate(): Date | null {
    return parseLocalDate(this.form.tanggal_audit);
  }

  set tanggalAuditDate(val: Date | null) {
    this.form.tanggal_audit = val ? localISODate(val) : "";
    if (val) {
      this.form.periode_bulan = val.getMonth() + 1;
      this.form.periode_tahun = val.getFullYear();
    }
  }

  get waktuMulaiDate(): Date | null {
    const [h, m] = (this.form.waktu_mulai || "").split(":").map(Number);
    if (Number.isNaN(h) || Number.isNaN(m) || !this.form.waktu_mulai) return null;
    return new Date(2000, 0, 1, h, m);
  }

  set waktuMulaiDate(val: Date | null) {
    this.form.waktu_mulai = val ? `${pad2(val.getHours())}:${pad2(val.getMinutes())}` : "";
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: Record<string, string> = {};
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      const res = await AuditPembersihanLingkunganService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.form = emptyForm();
    this.mode = "create";
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    if (!this.canSubmitCreate) return;
    this.creating = true;
    try {
      const payload = { ...this.form, waktu_mulai: this.form.waktu_mulai || null };
      const res = await AuditPembersihanLingkunganService.create(payload);
      this.currentSessionId = res.data.data.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.openDetailById(item.id);
  }

  openDetailById(id: number) {
    this.currentSessionId = id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    AuditPembersihanLingkunganService.printPdf(id);
  }

  formatTanggal(s: string): string {
    const d = parseLocalDate(s);
    return d ? d.toLocaleDateString("id-ID") : "-";
  }
}
